export function initBlog(): void {
  const btn = document.querySelector<HTMLButtonElement>(".js-load-more-posts");
  if (!btn) return;

  const items = document.querySelector<HTMLElement>(".blog__items");
  if (!items) return;

  btn.addEventListener("click", async () => {
    const page     = parseInt(btn.dataset.page ?? "2", 10);
    const category = btn.dataset.category ?? "";
    const ajaxUrl  = btn.dataset.ajaxUrl ?? "";

    btn.disabled = true;

    const body = new URLSearchParams({
      action:   "load_more_posts",
      page:     String(page),
      category,
    });

    try {
      const res  = await fetch(ajaxUrl, { method: "POST", body });
      const json = await res.json();

      if (!json.success) return;

      items.insertAdjacentHTML("beforeend", json.data.html);

      if (json.data.has_more) {
        btn.dataset.page = String(page + 1);
        btn.disabled = false;
      } else {
        btn.closest<HTMLElement>(".blog__bottom")?.remove();
      }
    } catch {
      btn.disabled = false;
    }
  });
}
